import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Card, Modal, Input, message, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setBreadcrumbList } from "../../../store/menuInfo/menuInfo";
import apis from "../../../apis";
import "./index.scss";

const { TextArea } = Input;

const icon = (
  <svg
    t="1768445143835"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2606"
    width="200"
    height="200"
  >
    <path
      d="M351.2 227l18.8 12.6c0.2 0.1 0.5 0.2 0.7 0.1l21-8.4c0.6-0.2 1.2 0.3 1 0.9l-6.1 21.8c-0.1 0.2 0 0.5 0.2 0.7l14.5 17.4c0.4 0.5 0.1 1.3-0.6 1.3l-22.6 0.9c-0.3 0-0.5 0.1-0.6 0.4l-12.1 19.1c-0.3 0.6-1.2 0.5-1.4-0.1l-7.8-21.2c-0.1-0.2-0.3-0.4-0.5-0.5l-21.9-5.6c-0.6-0.2-0.8-1-0.3-1.4l17.8-14c0.2-0.2 0.3-0.4 0.3-0.7l-1.5-22.6c-0.1-0.6 0.6-1 1.1-0.7zM230.7 347.1l22.6 1.5c0.3 0 0.5-0.1 0.7-0.3l14-17.8c0.4-0.5 1.2-0.3 1.4 0.3l5.6 21.9c0.1 0.3 0.2 0.5 0.5 0.5l21.2 7.8c0.6 0.2 0.7 1.1 0.1 1.4l-19.1 12.1c-0.2 0.1-0.4 0.4-0.4 0.6l-0.9 22.6c0 0.7-0.8 1-1.3 0.6l-17.4-14.5c-0.2-0.2-0.5-0.2-0.7-0.2l-21.8 6.1c-0.6 0.2-1.2-0.4-0.9-1l8.4-21c0.1-0.2 0.1-0.5-0.1-0.7L230 348.3c-0.4-0.5 0-1.3 0.7-1.2zM514.2 840.6l-10-20.3c-0.1-0.2-0.3-0.4-0.6-0.4l-22.4-3.3c-0.6-0.1-0.9-0.9-0.4-1.3l16.2-15.8c0.2-0.2 0.3-0.4 0.2-0.7l-3.8-22.3c-0.1-0.6 0.6-1.1 1.1-0.8l20 10.5c0.2 0.1 0.5 0.1 0.7 0l20-10.5c0.6-0.3 1.3 0.2 1.1 0.8l-3.8 22.3c0 0.3 0 0.5 0.2 0.7l16.2 15.8c0.5 0.5 0.2 1.2-0.4 1.3l-22.4 3.3c-0.3 0-0.5 0.2-0.6 0.4l-10 20.3c-0.1 0.6-1 0.6-1.3 0zM678.7 797l-18.8-12.6c-0.2-0.1-0.5-0.2-0.7-0.1l-21 8.4c-0.6 0.2-1.2-0.3-1-0.9l6.1-21.8c0.1-0.2 0-0.5-0.2-0.7l-14.5-17.4c-0.4-0.5-0.1-1.3 0.6-1.3l22.6-0.9c0.3 0 0.5-0.1 0.6-0.4l12.1-19.1c0.3-0.6 1.2-0.5 1.4 0.1l7.8 21.2c0.1 0.2 0.3 0.4 0.5 0.5l21.9 5.6c0.6 0.2 0.8 1 0.3 1.4l-17.8 14c-0.2 0.2-0.3 0.4-0.3 0.7l1.5 22.6c0.1 0.6-0.6 1-1.1 0.7zM799.2 676.9l-22.6-1.5c-0.3 0-0.5 0.1-0.7 0.3l-14 17.8c-0.4 0.5-1.2 0.3-1.4-0.3l-5.6-21.9c-0.1-0.3-0.2-0.5-0.5-0.5l-21.2-7.8c-0.6-0.2-0.7-1.1-0.1-1.4l19.1-12.1c0.2-0.1 0.4-0.4 0.4-0.6l0.9-22.6c0-0.7 0.8-1 1.3-0.6l17.4 14.5c0.2 0.2 0.5 0.2 0.7 0.2l21.8-6.1c0.6-0.2 1.2 0.4 0.9 1l-8.4 21c-0.1 0.2-0.1 0.5 0.1 0.7l12.6 18.8c0.4 0.4-0.1 1.2-0.7 1.1zM515.7 183.4l10 20.3c0.1 0.2 0.3 0.4 0.6 0.4l22.4 3.3c0.6 0.1 0.9 0.9 0.4 1.3l-16.2 15.8c-0.2 0.2-0.3 0.4-0.2 0.7l3.8 22.3c0.1 0.6-0.6 1.1-1.1 0.8l-20-10.5c-0.2-0.1-0.5-0.1-0.7 0l-20 10.5c-0.6 0.3-1.3-0.2-1.1-0.8l3.8-22.3c0-0.3 0-0.5-0.2-0.7L481 208.7c-0.5-0.5-0.2-1.2 0.4-1.3l22.4-3.3c0.3 0 0.5-0.2 0.6-0.4l10-20.3c0.1-0.6 1-0.6 1.3 0zM936.4 436.5L238.8 839.3c-22.5 13-51.4 5.3-64.4-17.3L70.3 641.7c-13-22.5-5.3-51.4 17.3-64.4l697.6-402.8c22.5-13 51.4-5.3 64.4 17.3l104.1 180.4c13 22.4 5.3 51.3-17.3 64.3z m-841 154.4c-15 8.7-20.2 27.9-11.5 42.9L188 814.2c8.7 15 27.9 20.2 42.9 11.5l697.6-402.8c15-8.7 20.2-27.9 11.5-42.9L836 199.6c-8.7-15-27.9-20.2-42.9-11.5L95.4 590.9z"
      p-id="2607"
    ></path>
    <path
      d="M936.4 436.5L238.8 839.3c-22.5 13-51.4 5.3-64.4-17.3L70.3 641.7c-13-22.5-5.3-51.4 17.3-64.4l697.6-402.8c22.5-13 51.4-5.3 64.4 17.3l104.1 180.4c13 22.4 5.3 51.3-17.3 64.3z m-841 154.4c-15 8.7-20.2 27.9-11.5 42.9L188 814.2c8.7 15 27.9 20.2 42.9 11.5l697.6-402.8c15-8.7 20.2-27.9 11.5-42.9L836 199.6c-8.7-15-27.9-20.2-42.9-11.5L95.4 590.9zM317.2 431.1c1.5-0.8 2.6-2.1 3.3-3.7 17.5-40.3 47.5-75.5 88.4-99.1 40.9-23.6 86.4-32 130-27 1.7 0.2 3.4-0.1 4.8-1 6.5-3.8 4.5-13.8-3-14.6-46.9-5.4-95.8 3.6-139.8 29s-76.2 63.2-95 106.6c-2.9 6.8 4.8 13.5 11.3 9.8zM719.4 575.4c-1.7 1-2.9 2.5-3.5 4.3-15.9 47.3-48.4 89.2-94.9 116s-99 34-147.9 24.2c-1.9-0.4-3.8-0.1-5.5 0.9-6.3 3.6-4.7 13.1 2.4 14.5 52.5 10.6 108.9 2.9 158.9-26 49.9-28.8 84.8-73.8 101.9-124.6 2.3-6.8-5.1-12.9-11.4-9.3z"
      p-id="2608"
    ></path>
    <path
      d="M883.5 480.7c-2.6 1.5-4.2 4.4-4 7.5 8.6 134.3-57.6 268.6-181.9 340.3s-273.6 62-385.7-12.6c-2.5-1.7-5.8-1.8-8.4-0.3-5.1 3-5.3 10.3-0.4 13.5 34.2 22.8 72.3 40.1 113.2 51.1 98.3 26.3 201.1 12.8 289.2-38.1S856.8 709 883.1 610.6c11-40.9 15-82.5 12.3-123.5-0.3-5.9-6.8-9.4-11.9-6.4zM145.8 530c2.5-1.5 4-4.2 3.9-7.1-3.7-130 62.2-258 182.5-327.4 120.3-69.4 264-62.5 374.7 5.6 2.5 1.5 5.6 1.6 8.2 0.1 5.2-3 5.3-10.6 0.2-13.7-31.2-19.2-65.3-34-101.7-43.7-98.3-26.3-201.1-12.8-289.2 38.1S173.1 315 146.8 413.4c-9.8 36.4-14 73.5-13 110.2 0.2 6 6.6 9.6 11.8 6.6l0.2-0.2z"
      p-id="2609"
    ></path>
    <path
      d="M329.3 539.1l12.8 22.2-12.3 7.1-6.3-10.9-83.5 48.2 6.3 10.9-11.9 6.9-12.8-22.2 48.9-28.2c-3.4-2.5-7.6-5.8-11.2-8l10.5-10.7c4.9 3.2 11.3 7.4 14.9 10.2l-0.8 0.8 45.4-26.3z m-32.1 54.6l40.2-23.2 35.6 61.7-12 6.9-3.5-6.1-28.2 16.3 13.1 22.8-12.4 7.2-13.1-22.8-28.3 16.3 3.8 6.6-11.6 6.7-35.9-62.2 40-23.1-6.8-11.8 12.4-7.2 6.7 11.9z m-34.7 34l7 12.2 28.3-16.3-7-12.2-28.3 16.3z m48.3 18.3l-7.1-12.3-28.3 16.3 7.1 12.3 28.3-16.3z m-7.6-41.8l7 12.2 28.2-16.3-7-12.2-28.2 16.3z m48.2 18.3l-7.1-12.3-28.2 16.3 7.1 12.3 28.2-16.3zM422.2 563.2c-3.7-2.9-10.6-7.5-17.1-11.7l36.7 63.5-11.5 6.6-32-55.5c3.2 14.2 4.8 28.3 4 38.4-3.2-2.6-8.9-6.4-12.9-8.4 2.1-14.8-1.6-38.6-7.6-57.3l-15.9 9.2-6.4-11.1 16.4-9.5-14-24.3 11.5-6.6 14 24.3 13.7-7.9 6.4 11.1-13.7 7.9 2.8 4.8c6.1 2.8 23.7 11.8 27.9 14l-2.3 12.5z m74.9-51.8c0.1 12-2 24.1-5.7 36.1 12.2 1.7 26.3 4.3 34.5 6.8l-4.7 13.4c-7.9-2.9-21.6-6-33.9-8.2-6.7 16.3-16.5 32-29.4 46.4-3.1-2-9.1-4.7-12.8-6.1 24.6-26.3 38.4-58.6 37.2-85.8l14.8-2.6z m-23.5-18.7c0.3 26.7-9 56.7-26.1 81.1-2.9-2-8.6-4.4-12-5.5 9.3-12.6 16.4-27.1 20.4-41.4-20.4 14-24.1 17-26.1 19.4-2.1-2.4-7.2-7.1-9.6-9.1 2.3-2.2 6-5.5 6.9-9.3 0.9-3.6 1.2-17.3 1.6-26.8l-23.4 13.5-6.3-11 32-18.6c-3.6-3.6-8.9-7.6-13.5-10.6l9.2-10c6.4 3.6 13.6 8.9 17.2 13.1l26.9-15.5 6.3 11-35.8 20.7c-0.3 9.1-0.6 20.7-1.2 29.8l19.2-12.5c0.6-5.2 0.9-10.7 0.7-15.6l13.6-2.7zM561 513.1c3.1 0.1 6.7 0.6 12.2 0.7 11.3 0.2 23-5.3 37.1-13.5 14.6-8.4 34.1-21.2 46.4-30.4 0.5 3.9 1.8 10.3 3.5 13.5-8.9 6-30.5 19.4-44.4 27.3-15.8 9.1-27.1 13.7-39.2 13.7-6.9 0-13.5-1.7-16.4 0-4.1 2.4-6.2 13.4-7.5 25.2l-13.1-5.7c2.3-10 5.6-18.9 9.8-24.5l-19.6-34-17.3 10-6.4-11.1 28.8-16.6 26.1 45.4z m-39-57.3c-8-3.3-23.4-7-34.9-9.3l4.2-11.9c11.1 1.9 26.5 5 34.5 8.2l-3.8 13z m65.4 48.1l-11.2 6.5-38.3-66.4 32.6-18.8c-9.1 0.7-19.2 2-27.6 3.3l4-11.1c6.5-1.3 14.2-2.5 21.9-3.5 3.6-5.4 6.8-11.8 9.3-17.6l-50.3 29-5.4-9.3 61.2-35.3 2-2 10.5 1.5c-2.9 10.5-8 22.2-14.2 32.7 4.1-0.4 7.6-0.6 10.7-0.5l16.7-9.6 31.9 55.2c3.1 5.4 3.7 8.7 0.9 12.4-2.8 3.8-8.1 7.1-16.3 11.8-2.1-2.7-5.8-5.9-8.8-7.8 5.5-2.8 10.4-5.8 11.8-6.7 1.6-0.9 1.8-1.7 0.9-3.3l-5.3-9.2-19.3 11.1 11.5 19.9-10.9 6.3-11.5-19.9-18.6 10.8 11.8 20.5z m-33.1-57.3l5.4 9.3 18.6-10.8-5.4-9.3-18.6 10.8z m34.7 17l-5.6-9.7-18.6 10.8 5.6 9.7 18.6-10.8z m-5.2-34l5.4 9.3 19.3-11.1-5.4-9.3-19.3 11.1z m35.3 16.6l-5.6-9.7-19.3 11.1 5.6 9.7 19.3-11.1zM694.5 432.6c3.2 0.2 6.9 0.7 12.1 0.6 11.2 0.3 23.2-5.5 37.4-13.7s33.6-20.9 45.2-29.7c0.4 4.3 2 11.6 3.9 15.4-8.6 5.7-30.2 19.1-42.7 26.4-16 9.3-27.6 14-40 14-7.4 0-14.2-1.8-17-0.2-4 2.3-5.3 13.8-6.2 25.3l-15.3-6.8c2.4-10.7 6-19.8 10.3-25.4L664.1 407l-16.4 9.5-6.5-11.2 28.2-16.3 25.1 43.6z m-40.7-55.3c-7.1-4.2-20.7-8.7-31.6-11.4l5.7-11.6c10.8 2.4 24.4 6.4 31.8 10.3l-5.9 12.7z m64.7-34.9l-48.6 28.1-6.6-11.4 48.6-28.1-12.7-22 12.3-7.1 12.7 22 16.8-9.7 6.6 11.4-16.8 9.7 27.2 47.1c4.3 7.5 4.5 11.9 0.5 16.6-3.8 4.8-11.8 9.9-23.9 16.9-2.5-3.2-7.6-7.5-11.2-9.9 9-4.7 18.2-10 20.7-11.6 2.4-1.5 2.9-2.7 1.6-5l-27.2-47z m-29.3 27.7c10.9 3.9 25.1 9.8 32.6 14.4l-6.5 12c-7.4-4.7-21.7-11.3-32.6-15.6l6.5-10.8z"
      p-id="2610"
    ></path>
  </svg>
);
const AuditDetail = ({ id, mode = "view", onBack }) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});
  const [rejectVisible, setRejectVisible] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setBreadcrumbList([
        { title: "充值方案" },
        { title: "方案审核", onClick: onBack },
        { title: "审核详情" },
      ])
    );
  }, [dispatch, onBack]);

  useEffect(() => {
    if (id) {
      setLoading(true);
      apis
        .getTopupAuditDetail({ topup_plan_audit_id: id })
        .then((res) => {
          if (res.code === 200) {
            setDetail(res.data || {});
          } else {
            message.error(res.message || "获取详情失败");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  const handleApprove = () => {
    const verId = detail?.ver?.topup_plan_ver_id;
    if (!verId) {
      message.error("无法获取方案版本ID，无法审核");
      return;
    }

    Modal.confirm({
      title: "确认通过",
      content: "确定要通过该审核吗？",
      onOk: () => {
        return apis
          .approveTopupAudit({
            topup_plan_ver_id: verId,
            comment: "审核通过",
          })
          .then((res) => {
            if (res.code === 200) {
              message.success("操作成功");
              onBack();
            } else {
              message.error(res.message || "操作失败");
            }
          });
      },
    });
  };

  const handleReject = () => {
    if (!rejectReason) {
      message.warning("请输入驳回原因");
      return;
    }
    const verId = detail?.ver?.topup_plan_ver_id;
    if (!verId) {
      message.error("无法获取方案版本ID，无法审核");
      return;
    }

    apis
      .rejectTopupAudit({
        topup_plan_ver_id: verId,
        comment: rejectReason,
      })
      .then((res) => {
        if (res.code === 200) {
          message.success("操作成功");
          setRejectVisible(false);
          onBack();
        } else {
          message.error(res.message || "操作失败");
        }
      });
  };

  const getPlanTypeText = (code) => {
    return code === "ENTERPRISE_EDITION"
      ? "企业版"
      : code === "PERSONAL_EDITION"
      ? "个人版"
      : code;
  };

  const { plan = {}, ver = {}, audit = {}, flows = [] } = detail;

  const isApproved = audit?.audit_status_code === 'APPROVED' || audit?.audit_status_code === 'AGREE';

  return (
    <div className="audit-detail-container">
      <Spin spinning={loading}>
        <div className="content-body">
          <Card bordered={false} style={{ position: 'relative' }}>
            {isApproved && (
              <div style={{ position: 'absolute', right: 20, top: 0, zIndex: 1 }}>
                {React.cloneElement(icon, { width: 180, height: 180, fill: '#61D4AD' })}
              </div>
            )}
            <div className="itemTitle2">
              <span>
                01<i></i>
              </span>
              基本信息
            </div>

            <Form
              layout="horizontal"
              labelCol={{ flex: "90px" }}
              wrapperCol={{ flex: "auto" }}
              labelAlign="left"
              colon={false}
            >
              <div className="subscriptionItemsContent">
                <Form.Item label="方案类别" required>
                  <span className="view-text">
                    {getPlanTypeText(plan.topup_plan_type_code)}
                  </span>
                </Form.Item>
                <Form.Item label="方案编码" required>
                  <span className="view-text">{plan.topup_plan_code}</span>
                </Form.Item>
                <Form.Item label="方案名称" required>
                  <span className="view-text">{ver.topup_plan_name}</span>
                </Form.Item>
                <Form.Item label="权益点" required>
                  <span className="view-text">{ver.equity_point}</span>
                </Form.Item>
                <Form.Item label="原价 (元)" required>
                  <span className="view-text">
                    ¥{Number(ver.original_price || 0).toFixed(2)}
                  </span>
                </Form.Item>
                <Form.Item label="折扣价 (元)" required>
                  <span className="view-text">
                    {ver.discount_price
                      ? `¥${Number(ver.discount_price).toFixed(2)}`
                      : "-"}
                  </span>
                </Form.Item>
                <Form.Item
                  label="方案描述"
                  className="full-width"
                  labelCol={{ flex: "90px" }}
                  wrapperCol={{ flex: "auto" }}
                >
                  <span className="view-text">
                    {ver.topup_plan_desc || "-"}
                  </span>
                </Form.Item>
              </div>
            </Form>

            <div className="itemTitle2" style={{ marginTop: "24px" }}>
              <span>
                02<i></i>
              </span>
              流程
            </div>

            <div className="process-list">
              <div className="process-header-line"></div>
              {flows.map((item, index) => {
                let statusText = "";
                if (item.processing_type_code === "SUBMIT")
                  statusText = "提交审核";
                else if (item.processing_type_code === "APPROVED")
                  statusText = "审核通过";
                else if (item.processing_type_code === "REJECTED")
                  statusText = "审核驳回";
                else statusText = item.processing_type_code;

                return (
                  <div
                    className="process-item"
                    key={item.topup_plan_audit_flow_id || index}
                  >
                    <div className="step-name">{statusText}</div>
                    <div className="user-info">
                      <Avatar
                        size={24}
                        src={item.processor_photo}
                        icon={<UserOutlined />}
                        style={{ marginRight: 8 }}
                      />
                      <span className="name">
                        {item.processor_name || "System"}
                      </span>
                    </div>
                    <div className="time">{item.processing_time || "-"}</div>
                    <div className="remark">{item.comment || ""}</div>
                  </div>
                );
              })}
            </div>
          </Card>
        </div>

        <div className="footer-actions">
          {mode === "audit" ? (
            <div style={{ display: "flex", gap: "20px" }}>
              <Button onClick={onBack} style={{ width: "120px" }}>
                取消
              </Button>
              <Button
                danger
                onClick={() => setRejectVisible(true)}
                style={{ width: "120px" }}
              >
                驳回
              </Button>
              <Button
                type="primary"
                onClick={handleApprove}
                style={{ width: "120px" }}
              >
                同意
              </Button>
            </div>
          ) : (
            <Button onClick={onBack} style={{ width: "120px" }}>
              关闭
            </Button>
          )}
        </div>
      </Spin>

      <Modal
        title="驳回审核"
        open={rejectVisible}
        onOk={handleReject}
        onCancel={() => setRejectVisible(false)}
      >
        <TextArea
          rows={4}
          placeholder="请输入驳回原因"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default AuditDetail;
